import { Flex } from '@radix-ui/themes'
import { Button } from '../Button'

type Props = {
  cancelLabel?: string
  confirmLabel?: string
  variant?: 'primary' | 'danger'
  onCancel?: () => void
  onConfirm?: () => void
  showCancel?: boolean
  disabled?: boolean
  loading?: boolean
}

export const DialogFooter = ({
  cancelLabel = 'Cancel',
  onCancel,
  onConfirm,
  confirmLabel = 'Confirm',
  variant = 'primary',
  showCancel,
  disabled,
  loading,
}: Props) => {
  return (
    <Flex gap="3" mt="4" justify="end">
      {showCancel && !loading && (
        <Button onClick={onCancel} variant="soft" color="gray">
          {cancelLabel}
        </Button>
      )}
      <Button
        loading={loading}
        onClick={onConfirm}
        variant="solid"
        disabled={disabled}
        color={variant === 'primary' ? 'blue' : variant === 'danger' ? 'red' : 'gray'}
      >
        <span>{confirmLabel}</span>
      </Button>
    </Flex>
  )
}
